function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#482874",
  d: "M66.37 30.57C64.23 19.91 95.59 5.82 95.59 5.82s32.83 12.56 29.21 24.75c-2.27 7.63-29.53 12-29.53 12s-27.36-4.34-28.9-12z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#8B60F7",
  d: "M95.27 42.52c7.66 8.58 10.91 19.78 10.29 26.72h30.86a69.63 69.63 0 00-11.62-38.67c-.61 0-1.21-.06-1.84-.06-12.96 0-21.86 5.27-27.69 12.01zM95.59 5.82A67.16 67.16 0 0068.21 0C30.54 0 0 31 0 69.24h30.68c-1-8 5.91-37.49 35.7-38.67A68.64 68.64 0 0195.59 5.82z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA600",
  d: "M68.21 30.51c-.63 0-1.23 0-1.83.06a69.64 69.64 0 00-11.63 38.67h30.68c-.6-4.8 1.63-17.23 9.84-26.72a35.25 35.25 0 00-27.06-12.01zM191.17 69.24C191.17 31 160.64 0 123 0a67.11 67.11 0 00-27.41 5.82 68.75 68.75 0 0129.21 24.75c25.78 1.16 36.6 26.48 35.51 38.67z"
});

var SvgVeengu = function SvgVeengu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 191.17 69.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVeengu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/veengu.76c685ed.svg";
export { ForwardRef as ReactComponent };